import { FormDataShape } from './useCheckoutController.types';

export const initialFormData: FormDataShape = {
  email: '',
  fullName: '',
  cpf: '',
  postalCode: '',
  state: '',
  city: '',
  neighborhood: '',
  address: '',
  number: '',
  complement: '',
  cardNumber: '',
  cardName: '',
  cardExpiry: '',
  cardCvv: '',
  installments: '1',
  phoneNumber: '',
};